import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BrowserIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-browser"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M52,0 L16,0 C14.3427153,0 13,1.34271525 13,3 L13,31 C13,32.6572847 14.3427153,34 16,34 L52,34 C53.6572847,34 55,32.6572847 55,31 L55,3 C55,1.34271525 53.6572847,0 52,0 Z M16,2 L52,2 C52.5527153,2 53,2.44728475 53,3 L53,31 C53,31.5527153 52.5527153,32 52,32 L16,32 C15.4472847,32 15,31.5527153 15,31 L15,3 C15,2.44728475 15.4472847,2 16,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M18 4C18 4.552 17.552 5 17 5 16.448 5 16 4.552 16 4 16 3.448 16.448 3 17 3 17.552 3 18 3.448 18 4M50.0741 5 26.9261 5C26.4141 5 26.0001 4.585 26.0001 4.074L26.0001 3.926C26.0001 3.415 26.4141 3 26.9261 3L50.0741 3C50.5851 3 51.0001 3.415 51.0001 3.926L51.0001 4.074C51.0001 4.585 50.5851 5 50.0741 5"
          fill="#00000"
          className={styles.defaultColor}
        />
        <polygon fill="#00000" className={styles.defaultColor} points="15 7 53 7 53 6 15 6" />
        <path
          d="M21 4C21 4.552 20.552 5 20 5 19.448 5 19 4.552 19 4 19 3.448 19.448 3 20 3 20.552 3 21 3.448 21 4M24 4C24 4.552 23.552 5 23 5 22.448 5 22 4.552 22 4 22 3.448 22.448 3 23 3 23.552 3 24 3.448 24 4"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M34,11 C29.5817153,11 26,14.5817153 26,19 C26,23.4182847 29.5817153,27 34,27 C38.4182847,27 42,23.4182847 42,19 C42,14.5817153 38.4182847,11 34,11 Z M34,13 C37.3137153,13 40,15.6862847 40,19 C40,22.3137153 37.3137153,25 34,25 C30.6862847,25 28,22.3137153 28,19 C28,15.6862847 30.6862847,13 34,13 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <path
          d="M33.5625,11 C35.8322648,11 37.1875,14.6141982 37.1875,19 C37.1875,23.2883396 35.8918283,26.8389879 33.712458,26.9946768 L33.5625,27 L33.5625,25 C34.1925625,25 35.1875,22.3466587 35.1875,19 C35.1875,15.7517724 34.2502275,13.1566787 33.6190061,13.006836 L33.5625,13 L33.5625,11 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
          points="40.563 18 40.563 20 27.438 20 27.438 18"
        />
        <path
          d="M34.4375,11 L34.4375,13 C33.8074375,13 32.8125,15.6533413 32.8125,19 C32.8125,22.2482276 33.7497725,24.8433213 34.3809939,24.993164 L34.4375,25 L34.4375,27 C32.1677352,27 30.8125,23.3858018 30.8125,19 C30.8125,14.7116604 32.1081717,11.1610121 34.287542,11.0053232 L34.4375,11 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
